import BodyText from 'LuxKit/Typography/BodyText'
import React from 'react'
import styled from 'styled-components'
import TextButton from '../../../../LuxKit/Button/TextButton'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import { useIntl } from 'react-intl'

const ButtonSet = styled(BodyText)`
  display: flex;
  align-items: center;

  ${mediaHoverable} {
    > *:hover {
      transition: color 0.2s;
      color: ${props => props.theme.palette.brand.primary.darkest};
    }
  }
`

interface Props {
  className?: string
  showReset?: boolean
  showRemove?: boolean
  onReset?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onRemove?: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function OccupancyItemActions(props: Props) {
  const { className, showReset, showRemove, onReset, onRemove } = props
  const intl = useIntl()

  return (
    <ButtonSet variant="large" className={className}>
      {showReset &&
        <TextButton kind="tertiary" onClick={onReset}>
          {intl.formatMessage({
            id: 'jnSJnf+uTO',
            defaultMessage: 'Reset',
            description: 'Button text to reset occupancy item in the occupancy or guest picker',
          })}
        </TextButton>}
      {showRemove &&
        <TextButton kind="tertiary" onClick={onRemove}>
          {intl.formatMessage({
            id: 'tvv3FDiCFJ',
            defaultMessage: 'Remove',
            description: 'Button text to remove a room from occupancy selection',
          })}
        </TextButton>}
    </ButtonSet>
  )
}

export default React.memo(OccupancyItemActions)
